import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CommentsV4Service } from '@core/services/comments/comments-v4.service';

import { CommentsConfigActions } from './comments-config.actions';

@Injectable()
export class CommentsConfigEffects {
  private readonly actions$ = inject(Actions);
  private readonly commentsV4Service = inject(CommentsV4Service);

  loadCommentableTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommentsConfigActions.loadCommentableTypes),
      switchMap(({ dataSpaceId }) =>
        this.commentsV4Service.getCommentableTypes$(dataSpaceId).pipe(
          map(({ entityTypes }) =>
            CommentsConfigActions.loadCommentableTypesSuccess({ entityTypes })
          ),
          catchError((error) =>
            of(
              CommentsConfigActions.loadCommentableTypesFailure({
                error: error?.errorMessage ?? 'Failed to load commentable types'
              })
            )
          )
        )
      )
    )
  );
}
